// extracted by mini-css-extract-plugin
export var productImage = "_rr-1";
export var viewLink = "_rr-2";
export var wishlistItem = "_rr-0";